import { useState } from "react";
import { apiFetch } from "../../../context/AuthContext";
import { BASE_URL } from "../utils/reportsHelpers";
import text from "../utils/reportsTranslations";

const useEmailModal = (language, currentUser) => {
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);
  const [emailLoading, setEmailLoading] = useState(false);
  const [emailStatus, setEmailStatus] = useState({ type: "", message: "" });
  const [emailForm, setEmailForm] = useState({
    recipients: [],
    subject: "",
    message: "",
    includeAttachment: true
  });
  const [downloadFormat, setDownloadFormat] = useState({});

  const handleShareReport = async (report, withAttachment) => {
    if (!currentUser) {
      setEmailStatus({
        type: "error",
        message: text[language].userInfoNotAvailable
      });
      return;
    }

    setEmailLoading(true);
    setEmailStatus({ type: '', message: '' });

    try {
      const response = await apiFetch(`${BASE_URL}/reports/email`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          type: report.category,
          format: emailForm.format || 'pdf',
          recipients: emailForm.recipients,
          subject: emailForm.subject || `${text[language].shareReport}: ${report.title}`,
          message: emailForm.message,
          includeAttachment: withAttachment,
          filters: {
            requestingUser: currentUser
          }
        })
      });

      const data = await response.json();

      if (data.success) {
        setEmailStatus({
          type: "success",
          message: data.message || text[language].reportSentSuccess
        });

        setEmailForm({
          recipients: [],
          subject: '',
          message: '',
          includeAttachment: true
        });
        setShowEmailModal(false);
      } else {
        throw new Error(data.error || text[language].errorSendingReport);
      }
    } catch (error) {
      setEmailStatus({
        type: "error",
        message: error.message || text[language].errorSendingReport
      });
    } finally {
      setEmailLoading(false);
    }
  };
  return {
    showEmailModal, setShowEmailModal,
    selectedReport, setSelectedReport,
    emailLoading,
    emailStatus, setEmailStatus,
    emailForm, setEmailForm,
    downloadFormat, setDownloadFormat,
    handleShareReport,
  };
};

export default useEmailModal;